import { render } from "./BillImport.vue?vue&type=template&id=70ad3417&scoped=true"
import script from "./BillImport.vue?vue&type=script&lang=js"
export * from "./BillImport.vue?vue&type=script&lang=js"

import "./BillImport.vue?vue&type=style&index=0&id=70ad3417&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70ad3417"]])

export default __exports__